import { providers, provider } from 'helpers/Providers';
import { mergeDeep } from 'helpers/Utils';
const common = {
    size: {
        font: 14,
        lineHeight: 1.2,
        space: 8,
        hairline: 1,
        bar: 44,
        icon: 24,
        maxWidth: 1366,
        horizontal: 8,
        vertical: 8,
    },
    devices: {
        mobileHeight: 667,
        desktopWidth: 860,
        xs: 575,
        sm: 576,
        md: 860,
        lg: 992,
        xl: 1200,
        xxl: 1400,
        // desktopHeight: 641,
        desktopHeight: 768,
        desktopLGHeight: 961,
    },
};
const themes = {
    main: {
        fontSize: {
            small: Math.round(common.size.font * 0.85) + 'px',
            regular: common.size.font + 'px',
            big: Math.round(common.size.font * 1.15) + 'px',
        },
        color: {
            primary: '#D60B52',
            secondary: '#6E6D6E',
            placeholder: '#A19FA1',
            rowBackground: '#FAFAFA',
            hairline: '#E5E6E5',
            // hairline: '#A19FA1', // Star Dust
            backdrop: 'rgba(0,0,0,0.2)',
            backgreen: '#eaffdd',
            backred: 'rgba(255,0,0,0.2)',
            backorange: '#ffe9ce',
            backlightgray: 'lightgray',
            background: '#FFFFFF',
            mercury: '#E5E6E5',
            traficWhite: '#F6F6F6',
            errorBackground: '#FFF0F0',
            errorText: '#FF0000',
            warningBackground: '#FFFBE6',
            warningText: '#5C3B00',
        },
        fontFamily: 'Lato',
        fontWeight: 300,
        lineHeight: common.size.lineHeight,
        size: {
            vertical: common.size.vertical,
            space: [
                0,
                common.size.space + 'px',
                common.size.space * 2 + 'px',
                common.size.space * 3 + 'px',
                common.size.space * 4 + 'px',
                common.size.space * 5 + 'px',
                common.size.space * 6 + 'px',
                common.size.space * 7 + 'px',
                common.size.space * 8 + 'px',
            ],
            hairline: common.size.hairline + 'px',
            bar: common.size.bar + 'px',
            icon: common.size.icon + 'px',
            horizontal: common.size.horizontal,
        },
        font: {
            family: 'Roboto',
            size: {
                big: Math.round(common.size.font * 1.2),
                regular: common.size.font,
                small: Math.round(common.size.font * 0.85),
            },
        },
        line: {
            big: Math.round(common.size.lineHeight * 1.15),
            regular: common.size.lineHeight,
            small: Math.round(common.size.lineHeight * 0.85),
        },
    },
    [providers.redsys]: {
        color: {
            primary: '#FB6325',
        },
    },
};
mergeDeep(themes.main, themes[provider]);
export const theme = Object.assign(Object.assign({}, themes.main), { common });
export default theme;
export const hairline = {
    all: {
        borderWidth: theme.size.hairline,
        borderColor: theme.color.hairline,
    },
    allMargingBlack: {
        borderWidth: theme.size.hairline,
        borderColor: 'black',
        marginTop: 100,
        marginBottom: 100,
    },
    top: {
        /*paddingLeft: 10,*/
        borderTopWidth: theme.size.hairline,
        borderTopColor: theme.color.hairline,
    },
    topPadding: {
        marginTop: 10,
        marginBottom: 10,
        borderTopWidth: theme.size.hairline,
        borderTopColor: theme.color.hairline,
    },
    bottomPadding: {
        marginLeft: 10,
        marginRight: 10,
        borderBottomWidth: theme.size.hairline,
        borderBottomColor: theme.color.hairline,
    },
    bottom: {
        borderBottomWidth: theme.size.hairline,
        borderBottomColor: theme.color.hairline,
    },
};
export const easing = {
    spring: 'cubic-bezier(0.23, 1, 0.32, 1)',
};
export const mediaQueries = {
    desktop: `@media only screen and (min-width: ${common.devices.desktopWidth}px)`,
    // mobile: `@media only screen and (max-width: ${common.devices.desktopWidth-1}px)`,
    mobile: `@media only screen and (hover: none), (pointer: coarse)`,
    xs: `@media only screen and (max-width: ${common.devices.xs - 1}px)`,
    sm: `@media only screen and (max-width: ${common.devices.sm - 1}px)`,
    md: `@media only screen and (max-width: ${common.devices.md - 1}px)`,
    lg: `@media only screen and (min-width: ${common.devices.lg - 1}px)`,
    xl: `@media only screen and (min-width: ${common.devices.xl}px)`,
    xxl: `@media only screen and (min-width: ${common.devices.xxl}px)`,
};
// @media screen and (orientation: landscape)
export const padding = (n = 1) => ({
    padding: common.size.horizontal * n,
});



//////////////////
// WEBPACK FOOTER
// ./src/Theme.ts
// module id = 4
// module chunks = 0